<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AdminAccounts',
}
</script>

<style scoped>
</style>
